export const sizeL = breakpoints => ({
  height: '52px',
  padding: '0 48px',
  [breakpoints.up('sm')]: {
    height: '56px',
  },
});

export const sizeM = {
  height: '48px',
  padding: '0 40px',
};

export const sizeS = {
  height: '40px',
  padding: '0 32px',
};

export const sizeXS = {
  height: '40px',
  padding: '0 16px',
};

export const disabledButton = {
  background: '#DADCDE !important',
  boxShadow: 'none !important',
};

export const smallButton = {
  height: '32px',
  minWidth: '55px',
  padding: '4px 16px',
};

export const label = {
  textAlign: 'center',
  fontFamily: 'Gilroy, Arial, sans-serif, dinpro-bold',
  fontWeight: 700,
  letterSpacing: '0.4px',
  fontSize: '16px',
  lineHeight: '20px',
  transition: 'color 0.3s ease-in-out, opacity 0.3s ease-in-out',
};

export const labelS = {
  textAlign: 'center',
  fontFamily: 'Gilroy, Arial, sans-serif, dinpro-bold',
  fontWeight: 700,
  letterSpacing: '0.4px',
  fontSize: '14px',
  lineHeight: '18px',
  transition: 'color 0.3s ease-in-out, opacity 0.3s ease-in-out',
};

export const disabledLabel = {
  color: 'rgba(0, 0, 0, 0.3) !important',
};

export const fullWidth = {
  textAlign: 'center',
  width: '100%',
};
